import React, { useState, FC } from 'react';
import { SpheraModal, SpheraDateTimePicker } from '@sphera-cloud/component-ui-reactjs';
import { Job } from 'src/store/slices/jobs/types';

const BASIC_WIDTH = 700;
const BASIC_HEIGHT = 521;

export interface FileDetailsModalProps {
  details: Job;
  closeModal: (b: boolean) => void;
  onAction: (date: Job) => void;
}

export const EditJobModal: FC<FileDetailsModalProps> = ({details, closeModal, onAction }) => {

  const [height, setHeight] = useState<number | string>(BASIC_HEIGHT);
  const [width, setWidth] = useState<number | string>(BASIC_WIDTH);
  const [expireDate, setExpireDate] = useState<string | undefined>(details.expirationDate);
  const [maximize, setMaximize] = useState(true);
  const [minimize, setMinimize] = useState(false);

  return (
    <SpheraModal
      title="Edit Expiration"
      onClose={() => {
        closeModal(false);
      }}
      onCancel={() => {
        closeModal(false);
      }}
      onAction={() => {
        onAction({
          ...details,
          expirationDate: expireDate,
        });
      }}
      className="ds-file-details"
      actions
      actionText={'Update'}
      height={height}
      width={width}
      useMaximizeButton={maximize}
      useMinimizeButton={minimize}
      onMaximize={() => {
        setHeight('100%');
        setWidth('100%');
        setMaximize(false);
        setMinimize(true);
      }}
      onMinimize={() => {
        setHeight(BASIC_HEIGHT);
        setWidth(BASIC_WIDTH);
        setMaximize(true);
        setMinimize(false);
      }}
      actionDisabled={!expireDate}
    >
      <div className="file-details">
        <div className="file-details--expire-label">Expiration</div>
        <SpheraDateTimePicker min={new Date()} value={expireDate ?? null} onChange={(e: any) => setExpireDate(e?.value ?? null)} />
      </div>
    </SpheraModal>
  );
};
